import { render, staticRenderFns } from "./LinkDownload.vue?vue&type=template&id=d908d3e0&scoped=true&lang=pug"
import script from "./LinkDownload.vue?vue&type=script&lang=ts"
export * from "./LinkDownload.vue?vue&type=script&lang=ts"
import style0 from "./LinkDownload.vue?vue&type=style&index=0&id=d908d3e0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d908d3e0",
  null
  
)

export default component.exports